export const createDefaultAgencyName = (agencyFilters = {}) => {
  const { agencyName } = agencyFilters;
  const agencyString = agencyName;
  let agencyObj = {};
  if (agencyString) {
    agencyObj = { name: agencyString, value: agencyString, agencyName: agencyString };
  }
  return agencyObj;
};
